import React from 'react'
import { Canvas } from 'react-three-fiber'
import {
  Lights,
  ZoomCamera,
  CaptureDragRotate
} from '../../three'
import Puzzle from './Puzzle'
import { getStepValues } from '../../../shared/utils'

const cameraDefaults = {
  aspect: window.innerWidth / window.innerHeight,
  position: [0, 400, 400]
}

function PuzzleCanvas({
  puzzle,
  zoom,
  rotation,
  complete,
  setRotation,
  setZoom,
  ...props
}) {
  return puzzle ? (
    <CaptureDragRotate
      enableDrag={complete}
      initialRotation={rotation}
      onRotate={setRotation}
      initialZoom={zoom}
      onZoom={setZoom}
      zoomConfig={{
        bounds: puzzle.zoomBounds,
        steps: getStepValues(puzzle.zoomBounds, 10),
        increment: 0.0001
      }}
      {...props}>
      <Canvas
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
        <Lights />
        <ZoomCamera
          zoom={zoom}
          focalPoint={[0, 0, 0]}
          {...cameraDefaults}
        />
        <React.Suspense fallback={<mesh />}>
          <Puzzle
            config={puzzle}
            complete={complete}
            rotation={complete ? rotation : [0, 0, 0]}
          />
        </React.Suspense>
        <polarGridHelper
          position={[0, -100, 0]}
          args={[200, 16, 8, 64, 0x333333, 0x666666]}
        />
      </Canvas>
    </CaptureDragRotate>
  ) : null
}

export default PuzzleCanvas
